"use client"

import {useEffect, useState} from "react";
import {useApi} from "@/lib/hook";
import {Select} from "@/theme/ui";

export const PermissionsSelect = ({onInitHandler, userPermissions = [], userRoles, ...rest}) => {
    const [options, setOptions] = useState([])

    const {data: permission} = useApi({
        route: {name: 'roles.permissions'},
        setting: {
            select: (data) => data.data,
            staleTime: Infinity,
        }
    })

    const {data: roles} = useApi({
        route: {name: 'roles.all'},
        data: {
            include: 'permissions',
        },
        setting: {
            select: (data) => data.data,
            staleTime: Infinity,
        }
    })

    useEffect(()=>{
        if (userPermissions && permission && userRoles && roles){
            const rolePermissions = roles.find((item)=>userRoles.includes(item.name))?.permissions

            if (rolePermissions){

                setOptions(permission.filter((permissions)=>!rolePermissions.find((item)=>item.name === permissions.name)))
                const newPermissions = userPermissions.filter((permissions)=>!rolePermissions.find((item)=>item.name === permissions))

                if (!rest.value && onInitHandler){
                    onInitHandler(newPermissions)
                }
            }
        }

        if (!userRoles){
            setOptions(permission)
        }
    }, [roles, permission, userRoles])

    return (
        <>
            <Select
                mode={'multiple'}
                style={{
                    width: '100%',
                }}
                fieldNames={{value: 'name', label: 'title'}}
                options={options}
                {...rest}
            />
        </>
    )
}